import React, { useState } from "react";
import { Box, Modal, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { savePassType, updatePassType } from "../../services/PassTypeService";
import CancelPresentationIconButton from "../../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";
import InputField from "../../../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../../../common/components/FormFields/CheckBoxField";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";
import { CapitalizeStatement } from "../../../../../common/components/Custom Hooks/CapitalizeStatement";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";

const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  maxHeight: "90%",
  width: "60%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 20,
  // borderRadius: "10px",
  overflowY: "auto",
  p: 2,
};

const defaultValues = {
  passTypeName: "",
  duration: null,
  status: true,
};

const durationData = [
  {
    id: 1,
    label: "Minute",
    borderColor: "border-blue-400",
    hoverBg: "hover:bg-blue-50",
    defaultTextColor: "text-blue-600",
    selectedbg: "bg-red-500 border-red-500",
  },
  {
    id: 2,
    label: "Hour",
    borderColor: "border-green-400",
    hoverBg: "hover:bg-green-50",
    defaultTextColor: "text-green-600",
    selectedbg: "bg-green-500 border-green-500",
  },
  {
    id: 3,
    label: "Month",
    borderColor: "border-blue-400",
    hoverBg: "hover:bg-blue-50",
    defaultTextColor: "text-blue-600",
  },
  {
    id: 4,
    label: "Year",
    borderColor: "border-green-400",
    hoverBg: "hover:bg-green-50",
    defaultTextColor: "text-green-600",
  },
];

const selectionColors = [
  // "bg-yellow-500 border-yellow-500",
  // "bg-pink-500 border-pink-500",
  // "bg-green-500 border-green-500",
];

function PassTypeModal(props) {
  const {
    addNewPassTypeModal,
    setAddNewPassTypeModal,
    populateTable,
    setIsBackdrop,
    selectedRow,
    setSelectedRow,
    isBackDrop,
  } = props;

  const schema = yup.object().shape({
    passTypeName: yup.string().trim().required("Course Name is required"),
  });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [finalObject, setFinalObject] = useState(null);
  const [durationCategory, setDurationCategory] = useState(null);

  const handleSaveClick = (data) => {
    const tempObj = {
      id: selectedRow !== null ? selectedRow?.Id : null,
      passType: CapitalizeStatement(data?.passTypeName),
      duration: data?.duration,
      durationLabel: durationCategory !== null ? durationCategory?.label : null,
      isActive: data?.status,
    };
    setFinalObject(tempObj);
    setPostConfirmationModal(true);
  };
  console.log("error", errors);

  const onSubmit = () => {
    setIsBackdrop(true);
    if (selectedRow === null) {
      savePassType(finalObject)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            setIsBackdrop(false);
            successAlert(res?.message);
            setPostConfirmationModal(false);
            setAddNewPassTypeModal(false);
            populateTable();
            reset(defaultValues);
            setDurationCategory(null);
            setSelectedRow(null);
            setFinalObject(null);
          } else {
            populateTable();
            errorAlert(res?.message);
            setIsBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setIsBackdrop(false);
        });
    } else {
      updatePassType(finalObject)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            setIsBackdrop(false);
            successAlert(res?.message);
            setPostConfirmationModal(false);
            setAddNewPassTypeModal(false);
            populateTable();
            reset(defaultValues);
            setDurationCategory(null);
            setSelectedRow(null);
            setFinalObject(null);
          } else {
            populateTable();
            errorAlert(res?.message);
            setIsBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setIsBackdrop(false);
        });
    }
  };
  React.useEffect(() => {
    if (selectedRow !== null) {
      setValue("passTypeName", selectedRow?.["Pass Type"]);
      setValue("status", selectedRow.Status);
      setValue("duration", selectedRow.Duration);
      setDurationCategory(
        durationData?.find(
          (item) => item?.label === selectedRow?.["Time Format"]
        )
      );
    } else {
      reset(defaultValues);
    }
  }, [selectedRow]);
  console.log("selectedRow", selectedRow);
  return (
    <div>
      <Modal
        open={addNewPassTypeModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={ModalStyles} className="w-[60%] rounded-lg">
          <form
            onSubmit={handleSubmit(handleSaveClick)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(handleSaveClick)();
              }
            }}
          >
            <div className="flex justify-between items-center whitespace-nowrap">
              <h1 className="text-lg font-semibold">
                {selectedRow !== null ? "Update" : "New"} Pass Type
              </h1>
              <CancelPresentationIconButton
                type={"button"}
                onClick={() => {
                  setAddNewPassTypeModal(false);
                  setSelectedRow(null);
                  setDurationCategory(null);
                }}
              />
            </div>
            <div className="mb-3">
              {" "}
              <CommonDivider color="#E0E0E0" />
            </div>
            <div className="flex gap-2 items-center ">
              <InputField
                name="passTypeName"
                label="Pass Type Name*"
                type={"text"}
                control={control}
                error={errors.passTypeName}
              />
              {/* <div className=' flex gap-2 items-center'> */}
              <InputField
                name="duration"
                label="Duration"
                type={"number"}
                control={control}
              />
              <div className="flex gap-3 items-center mr-3">
                <div className="flex space-x-2">
                  {durationData?.slice(0, 2)?.map((duration, idx) => (
                    <div key={duration?.id} className="relative group">
                      <button
                        type="button"
                        onClick={() => {
                          if (durationCategory?.id === duration.id) {
                            setDurationCategory(null);
                          } else {
                            setDurationCategory(duration);
                          }
                        }}
                        className={`
                                                    w-8 h-8 rounded-full text-sm font-medium flex items-center justify-center
                                                    transition-all duration-200 border
                                                    ${
                                                      durationCategory?.id ===
                                                      duration.id
                                                        ? `${duration.selectedbg} text-white border-transparent`
                                                        : `bg-white ${duration.borderColor} ${duration.defaultTextColor} ${duration.hoverBg}`
                                                    }
                                                  `}
                      >
                        {duration?.label?.charAt(0)?.toUpperCase()}
                      </button>

                      {/* Tooltip */}
                      <span className="absolute bottom-full mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                        {duration?.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              {/* </div> */}

              <CheckBoxField
                name="status"
                style={{ fontWeight: 500 }}
                control={control}
                label="Active"
              />

              <div className="flex gap-2  justify-end ">
                <CommonButton
                  label="Reset"
                  type="button"
                  className="resetButton bg-white text-customRed border border-customRed rounded px-4"
                  onClick={() => {
                    reset(defaultValues);
                    setDurationCategory(null);
                  }}
                />
                <CommonButton
                  label={selectedRow !== null ? "Update" : "Save"}
                  type="submit"
                  className="saveButton bg-customGreen text-white rounded px-5"
                />
              </div>
            </div>
          </form>
          {postConfirmationModal && (
            <ConfirmationModal
              confirmationOpen={postConfirmationModal}
              confirmationHandleClose={() => setPostConfirmationModal(false)}
              confirmationSubmitFunc={onSubmit}
              confirmationMsg={`Are you sure you want to ${
                selectedRow === null ? "Add" : "Update"
              } this Record?`}
              confirmationButtonMsg={"Confirm"}
              confirmationLabel={"Confirmation"}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default PassTypeModal;
